import React from 'react';
import RevealCharacterScene from 'game/scenes/test/RevealCharacterScene';

import GameService from 'services/Game.service';
import { Layout, Game } from 'components';

export default function RevealCharacterScenePage() {
  return (
    <GameService>
      <Layout>
        <Game
          config={{
            scene: [RevealCharacterScene],
            physics: {
              arcade: {
                gravity: { y: 0 },
                // debug: true,
              },
            },
          }}
        />
      </Layout>
    </GameService>
  );
}
